"use client"
import React, { useEffect, useRef } from "react";
import MapPointContent from "@/components/maps/MapPointContent";
import EmbeddedPostContent from "@/components/posts/EmbeddedPostContent";

import "@/components/maps/MapPointView.css";
import useApi from "@/components/api/useApi";

const MapPointView = ({
  name,
  observedRef,
  className,
  wrapperClassName,
  mapId,
  ownerId,
  point,
  numbered,
  onClick,
  external,
  supportsMediaSubmissions,
  enableComments,
  appendContent,
  idOverride
}) => {
  var anchorId = idOverride ?? point.id;

  const api = useApi();

  const submitMediaToMapPoint = (point, payload, callback, token) => {
    api
      .contributeMediaSubmissionToStoryMapPoint(
        name,
        mapId,
        point.id,
        payload,
        token
      )
      .then(mediaSubmission => {
        // console.log("contributeMediaSubmissionToStoryMapPoint SUCCESS", mediaSubmission);
        window.flash_messages.alertModal({
          heading: "Pending Approval",
          textContent: (
            <div className="pending-approval-msg">
              <span className="material-icons green">check_circle</span>
              <p>
                Your contribution as been sent to this community’s admin for
                review. If approved, your contribution will appear publicly.
              </p>
            </div>
          )
        });
        callback(true);
      })
      .catch(error => {
        callback(false);
      });
  };

  const renderPointContent = () => {
    if (point.type === "POST" && point.post) {
      return (
        <EmbeddedPostContent
          post={point.post}
          coordinates={
            point.location
              ? [point.location.longitude, point.location.latitude]
              : null
          }
        />
      );
    }

    return (
      <MapPointContent
        name={name}
        point={point}
        external={external}
        numbered={numbered}
        showTitle={true}
        mapId={mapId}
        ownerId={ownerId}
        onClick={onClick}
        supportsMediaSubmissions={supportsMediaSubmissions}
        onMediaSubmit={(payload, token, callback) => {
          submitMediaToMapPoint(point, payload, callback, token);
        }}
        showCaption={true}
        enableComments={enableComments}
      />
    );
  };

  return (
    <div
      className={`map-point-view ${className ?? ""}`}
      id={anchorId}
      key={point.id}
      ref={observedRef}
    >
      <span className="anchor" id={"anchor-" + anchorId} />
      <div
        className={`default-card-wrapper ${wrapperClassName ?? ""} ${
          onClick ? "clickable" : ""
        }`}
      >
        {renderPointContent()}
        {appendContent}
      </div>
    </div>
  );
};
export default MapPointView;
